import React, { useContext } from 'react'
import styled from 'styled-components'
import { FaInfoCircle } from 'react-icons/fa'

import { formatDate } from '../src/formatter'
import { HelpScout } from '../contexts/help-scout'

const BackfillFlag = styled.div`
  margin-top: 5px;
  text-align: center; 
  color: #666;
  font-size: 14px;
  > span {
    cursor: pointer;
    > span {
      color: #6682b5;
    }
  }
`

const Component = (props) => {
  const helpScout = useContext(HelpScout)
  return <div>
    <div className='flex items-center text-sm justify-center text-gray-500 cursor-pointer' onClick={() => helpScout.openBeacon('5f4bc41f2c7d3a352e918b52')}>
      <FaInfoCircle className='mr-2' />
      Only activities started after joining will count.
    </div>
    {props.joined && <div className='text-sm text-center text-gray-500'>You joined on {formatDate(props.joined, true)}</div>}
  </div>
}

  export default Component
